<template>
  <header id="appbar" v-if="excludeRoutes && !isLanding" class="appbar">
    <router-link
      :to="{ path: '/', query: $route.query }"
      v-if="routerName !== 'personas-form' && routerName !== 'empresas-form'"
      class="brand"
    >
      <img class="logo" src="@/assets/logo_conecta.svg" alt="Urgencias" />
    </router-link>

    <a v-else :href="trackedHref('/')" rel="noopener noreferrer" class="brand">
      <img class="logo" src="@/assets/logo_conecta.svg" alt="Urgencias" />
    </a>

    <v-icon
      aria-label="Menú de navegación"
      class="hamburguer_btn"
      :color="PrimaryColor"
      x-large
    >
      mdi-menu
    </v-icon>
  </header>
  <header v-else-if="isLanding" id="appbar" class="appbar_landing">
  <a :href="trackedHref('/urgconecta')" rel="noopener noreferrer" class="brand">
    <img class="logo" src="@/assets/logo_conecta.svg" alt="Urgencias" />
  </a>

  <div class="landing_right">
    <!-- Teléfono texto (desktop) -->
    <a class="landing_phone landing_phone--text" href="tel:08002204970">0800 220 4970</a>

    <!-- Teléfono ícono (mobile) -->
    <a class="landing_phone landing_phone--icon" href="tel:08002204970" aria-label="Llamar">
      <v-icon size="22">mdi-phone</v-icon>
    </a>

    <v-btn class="landing_cta" depressed rounded @click="goToCotizar">
      COTIZÁ TU PLAN
    </v-btn>
  </div>
</header>


</template>


<script>

import { withTrackingParams } from "@/utils/withTrackingParams";


export default {
  components:{},
  computed:
  {
    routerName()
    {
      return this.$route.name;
    },
    excludeRoutes()
    {

      const excludedRoutes = ["grupofamiliar", "atencionmedica","areaprotegida"];
      return !excludedRoutes.includes(this.$route.name);
    },
     isLanding() {
      return this.$route.path === "/urgconecta" || this.$route.name === "landing"
    },
    isGrupoFamiliar()
    {
      return this.$route.name === "grupofamiliar"
    },
    isAtencionMedica()
    {
      const excludedRoutes = ["atencionmedica", "area_protegida"];
      return !excludedRoutes.includes(this.$route.name);
    },
  },
   methods: {
    trackedHref(rawUrl) {
      return withTrackingParams(rawUrl, { query: this.$route?.query });
    },
    goToCotizar() {
       this.$router.push({ path: "/conecta/locations", query: this.$route?.query || {} });
    }
}
}
</script>

<style>
/* Alto del header (ajustá el valor a gusto) */
:root { --appbar-h: 80px; }

.appbar {
  top: 10px;
  z-index: 100;
  height: var(--appbar-h);
  background: #fff;
  display: flex;
  align-items: center;       /* centra verticalmente */
  justify-content: center;   /* centra horizontalmente */
  padding: 0 72px;           /* deja espacio para el icono a la derecha */
  margin-top: 20px;
}

.appbar_landing {
  top: 10px;
  z-index: 100;
  min-height: var(--appbar-h);
  height: auto;               /* ✅ permite 2 filas */
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  margin-top: 20px;
}


.landing_right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 24px;
}

/* desktop */
.landing_phone--icon { display: none; }
.landing_phone--text { display: inline-flex; }

.landing_phone {
  font-weight: 800;
  font-size: 18px;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
}

/* Botón estilo mockup */
.landing_cta {
  border-radius: 999px !important;
  padding: 0 18px !important;
  height: 40px !important;
  color: #fff !important;
  background: #64a9d6 !important;
  box-shadow: none !important;
}

.brand {
  height: 100%;
  display: flex;
  align-items: center;       /* el logo queda centrado dentro del header */
}

/* El logo se escala por alto, mantiene proporción */
.logo {
  height: calc(var(--appbar-h) - 20px);   /* margen interno */
  width: auto;                             /* mantiene aspect ratio */
  object-fit: contain;
  display: block;
  margin: 0;
}

/* Icono del menú alineado al centro vertical del header */
.hamburguer_btn {
  position: absolute !important;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden; /* mostralo en mobile si querés */
}



/* Responsive */
@media (max-width: 768px) {
  :root { --appbar-h: 64px; }

   .logo { height: 36px; }
  .appbar_landing {
    padding: 0 0px;
    margin-top: 12px;
  }

  .landing_right {
    gap: 12px;
    padding-right: 0;
  }

  /* En mobile: oculto el número y muestro el ícono */
  .landing_phone--text { display: none; }
  .landing_phone--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    text-decoration: none;
    color: #000;
  }

  /* Botón un poco más compacto */
  .landing_cta {
    height: 36px !important;
    padding: 0 14px !important;
    font-size: 12px !important;
    white-space: nowrap;
  }
}

@media (max-width:440px) {
  .appbar_landing {
    display: block;
    margin: 0px;
  }

  .landing-right {
    padding-left: 15px;
  }
}




</style>